import React from 'react'
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
function PopularBadge(){
  return (
    <>
    <VolunteerActivismIcon className='featuredArtistsBadgeIcon featuredArtistsBadgeVolunteer '/>
    </>
  )
}
export default PopularBadge
